// Cuenta Vaca — ocultar el badge externo ("Made with Emergent") sin tocar el DOM
// que React controla.
//
// FIX (bug crítico — pantalla blanca): la versión anterior usaba un
// MutationObserver que hacía node.remove() sobre cualquier <a> cuyo
// `.href` (URL ABSOLUTA resuelta por el navegador) incluyera la palabra
// "emergent". Como la app corre en un dominio que contiene "emergent"
// (ej. mobile-offline-2.emergent.host), CUALQUIER link interno de la app
// (<a href="/acciones/3">) matcheaba y el observer lo borraba del DOM real
// mientras React seguía creyendo que ese nodo existía. En el siguiente
// re-render, React intentaba insertBefore/removeChild sobre un nodo que ya
// no estaba → "NotFoundError" → crash → pantalla blanca.
//
// Fix: nunca tocar el DOM con JS. El badge apunta siempre a "emergent.sh"
// (dominio distinto al de la app), así que alcanza con ocultarlo por CSS
// estático e inyectado una sola vez. Cero MutationObserver, cero node.remove().

try {
  const style = document.createElement("style");
  style.id = "cuenta-vaca-hide-badge";
  style.textContent = `
    #emergent-badge,
    a[href*="emergent.sh"],
    a[href*="emergent-badge"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
      position: absolute !important;
      width: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
    }
  `;
  (document.head || document.documentElement).appendChild(style);
} catch (_) { /* ignore */ }

export default {};
